import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Container } from '../container';
import { useWindowSize } from '../../utils/helpers';
import { ABookDemoBtn } from '../abookdemo';

export const CustomCTA = ({ title, description }) => {
  const screenSize = useWindowSize();

  return (
    <section className="bg-black/3 py-10 sm:bg-white sm:py-20">
      <Container>
        <div
          className={classNames(
            'relative z-[1] flex flex-col items-center justify-center overflow-hidden rounded-2xl border border-black/10 bg-white p-6 sm:p-16',
            "before:absolute before:bottom-0 before:left-0 before:-z-[1] before:h-full before:w-full before:bg-[url('https://cdn.runalloy.com/landing/2025/cta-bg-1.webp')] before:bg-cover before:bg-bottom before:bg-no-repeat before:mix-blend-multiply"
          )}
        >
          <h2 className="mb-5 w-full text-center text-white text-h2-xs sm:w-11/12 sm:text-h2">
            {title}
          </h2>
          <p className="mb-6 text-center text-lg font-light text-white/80 sm:text-2xl">
            {description ? (
              description
            ) : (
              <>
                Eliminate bottlenecks. Automate faster. <br />
                Scale with confidence.
              </>
            )}
          </p>
          <div className="flex w-full flex-col items-center justify-center gap-2 sm:flex-row sm:gap-4">
            <ABookDemoBtn
              type="tertiary"
              fullWidth={screenSize.width < 768 ? true : false}
            />
          </div>
        </div>
      </Container>
    </section>
  );
};

CustomCTA.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};
